(function ($, drupalSettings, Drupal) {
	Drupal.mq = window.location.origin.indexOf('0.0.0.0') != -1;
	Drupal.eta = 300;

	Drupal.breakpoint = {
		small: 560,
		medium: 720,
		desktop: 960,
		large: 1200,
		max: 1060,
	};

	Drupal.killAnimation = $('.layout-builder-form').length > 0;

	Drupal.behaviors.global = {
		attach: function (context) {
		}
	};

	Drupal.behaviors.scrollInit = {
		attach: function (context) {
			var items = [
				'.c-hero-mask',
				'.h-default',
			];
			var checkScroll = function () {
				var windowBottom = $(window).scrollTop() + ($(window).height() * 0.25);
				$(items.join(',')).filter(':not(.js-initialized)').each(function () {
					if (windowBottom > $(this).offset().top) {
						$(this).addClass('js-initialized');
					}
				});
			};

			checkScroll();
			$(window).scroll(function () {
				checkScroll();
			});
		}
	};

	Drupal.behaviors.backTopTop = {
		attach: function (context) {
			$('.js-back-to-top',context).click(function(e) {
				e.preventDefault();
				$('html, body').animate({ scrollTop: 0 }, Drupal.eta);
			});
		}
	};

	Drupal.behaviors.hashbang = {
		attach: function (context) {

		}
	};

	var getAnimOpts = function (a, b, c) {
		if (!a) { return { duration: 'normal' }; }
		if (!!c) { return { duration: a, easing: b, complete: c }; }
		if (!!b) { return { duration: a, complete: b }; }
		if (typeof a === 'object') { return a; }
		return { duration: a };
	};
	var getUnqueuedOpts = function (opts) {
		return {
			queue: false,
			duration: opts.duration,
			easing: opts.easing
		};
	};

	$.fn.slideFadeIn = function (a, b, c) {
		var slideOpts = getAnimOpts(a, b, c), fadeOpts = getUnqueuedOpts(slideOpts);
		$(this).hide().css('opacity', 0).slideDown(slideOpts).animate({ opacity: 1 }, fadeOpts);
	};
	$.fn.slideFadeOut = function (a, b, c) {
		var slideOpts = getAnimOpts(a, b, c), fadeOpts = getUnqueuedOpts(slideOpts);
		$(this).show().css('opacity', 1).slideUp(slideOpts).animate({ opacity: 0 }, fadeOpts);
	};
})(jQuery, drupalSettings, Drupal);


(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.formFocus = {
		attach: function (context) {
      $('.form-item input',context).focus(function() {
        $(this).closest('.form-item').addClass('js-focus');
      }).blur(function() {
        Drupal.checkFormItemEmpty($(this));
      }).each(function() {
        Drupal.checkFormItemEmpty($(this));
      });
    }
  };

  Drupal.checkFormItemEmpty = function($item) {
    var $row = $item.closest('.form-item');
    $row.removeClass('js-focus');
    if ($item.val() != '') {
      $row.addClass('js-filled');
    }
    else {
      $row.removeClass('js-filled');
    }
  };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.removeOrphans = {
		attach: function (context) {
      Drupal.ophranage = new typemate($('#main')[0], {
        selector: 'h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, p, blockquote',
      }).apply();
      if ($('.h-default--home').length > 0) {
        Drupal.ophranageHome = new typemate($('.h-default--home')[0], {
          selector: 'p',
        }).apply();
      }
    }
  };
})(jQuery, drupalSettings, Drupal);
